<!-- Modal Impedimento -->
<div class="conflict-modal-backdrop" *ngIf="showModal"></div>
<div class="conflict-modal" *ngIf="showModal">
  <div class="conflict-card">
    <button type="button" class="close-btn" aria-label="Fechar" (click)="onCancel()">
      &times;
    </button>

    <div class="icon-wrapper">
      <div class="icon-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" class="alert-icon" aria-hidden="true" focusable="false">
          <path d="M56.3333 73.6673L47.6667 73.6673L47.6667 65.0007L56.3333 65.0007L56.3333 73.6673ZM56.3333 56.334L47.6667 56.334L47.6667 30.334L56.3333 30.334L56.3333 56.334ZM52 95.334C75.92 95.334 95.3333 75.9207 95.3333 52.0007C95.3333 28.0807 75.92 8.66732 52 8.66732C28.08 8.66732 8.66666 28.0807 8.66666 52.0007C8.66666 75.9207 28.08 95.334 52 95.334ZM52 17.334C71.11 17.334 86.6667 32.8907 86.6667 52.0007C86.6667 71.1107 71.11 86.6673 52 86.6673C32.89 86.6673 17.3333 71.1107 17.3333 52.0007C17.3333 32.8907 32.89 17.334 52 17.334Z" fill="currentColor"/>
        </svg>
      </div>
    </div>

    <div class="title-modal">
      {{ title }}
    </div>

    <div [ngClass]="{'geolocation-conflict-container': enableBulkActions}">
      <div class="alert-box">
        {{ getAlertMessage() }}
      </div>

      <div class="bulk-actions" *ngIf="enableBulkActions">
        <div class="bulk-action-item">
          <span class="bulk-label">Manter regra existente para todos</span>
          <div class="switch-wrapper" (click)="onToggleKeepExistingAll(!keepExistingRuleAll)">
            <div class="btn-switch" [ngClass]="{ 'btn-switch--on': keepExistingRuleAll }">
              <div class="btn-switch-circle" [ngClass]="{ 'btn-switch-circle--on': keepExistingRuleAll }"></div>
            </div>
            <span class="switch-text">{{ keepExistingRuleAll ? 'Sim' : 'Não' }}</span>
          </div>
        </div>

        <div class="bulk-action-item">
          <span class="bulk-label">Aplicar regra nova para todos</span>
          <div class="switch-wrapper" (click)="onToggleApplyNewAll(!applyNewRuleAll)">
            <div class="btn-switch" [ngClass]="{ 'btn-switch--on': applyNewRuleAll }">
              <div class="btn-switch-circle" [ngClass]="{ 'btn-switch-circle--on': applyNewRuleAll }"></div>
            </div>
            <span class="switch-text">{{ applyNewRuleAll ? 'Sim' : 'Não' }}</span>
          </div>
        </div>
      </div>

      <div class="custom-table-wrapper" [ngSwitch]="conflictLayout">
      <table class="custom-table" *ngSwitchCase="'unidade'">
        <thead>
          <tr>
            <th>Unidade</th>
            <th>Configuração</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conflict of conflicts; trackBy: trackByConflictId">
            <td>{{ getCompanyName(conflict) }}</td>
            <td>{{ getConfigurationName(conflict) }}</td>
            <td class="actions-cell">
              <div class="resolution-options">
                <label class="radio-option" [class.disabled-option]="isBulkActionActive">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="current"
                    [checked]="resolutions[conflict.id.toString()] === 'current'"
                    [disabled]="isBulkActionActive"
                    (change)="onResolutionChange(conflict.id.toString(), 'current')">
                  <span>Manter atual</span>
                </label>
                <label class="radio-option" [class.disabled-option]="isBulkActionActive">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="conflicting"
                    [checked]="resolutions[conflict.id.toString()] === 'conflicting'"
                    [disabled]="isBulkActionActive"
                    (change)="onResolutionChange(conflict.id.toString(), 'conflicting')">
                  <span>Aplicar nova</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="custom-table" *ngSwitchCase="'area'">
        <thead>
          <tr>
            <th>Área</th>
            <th>Configuração</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conflict of conflicts; trackBy: trackByConflictId">
            <td>{{ getAreaName(conflict) }}</td>
            <td>{{ getConfigurationName(conflict) }}</td>
            <td class="actions-cell">
              <div class="resolution-options">
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="current"
                    [checked]="resolutions[conflict.id.toString()] === 'current'"
                    (change)="onResolutionChange(conflict.id.toString(), 'current')">
                  <span>Manter atual</span>
                </label>
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="conflicting"
                    [checked]="resolutions[conflict.id.toString()] === 'conflicting'"
                    (change)="onResolutionChange(conflict.id.toString(), 'conflicting')">
                  <span>Aplicar nova</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="custom-table" *ngSwitchCase="'combinacao'">
        <thead>
          <tr>
            <th>Unidade</th>
            <th>Área</th>
            <th>Configuração</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conflict of conflicts; trackBy: trackByConflictId">
            <td>{{ getCompanyName(conflict) }}</td>
            <td>{{ getAreaName(conflict) }}</td>
            <td>{{ getConfigurationName(conflict) }}</td>
            <td class="actions-cell">
              <div class="resolution-options">
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="current"
                    [checked]="resolutions[conflict.id.toString()] === 'current'"
                    (change)="onResolutionChange(conflict.id.toString(), 'current')">
                  <span>Manter atual</span>
                </label>
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="conflicting"
                    [checked]="resolutions[conflict.id.toString()] === 'conflicting'"
                    (change)="onResolutionChange(conflict.id.toString(), 'conflicting')">
                  <span>Aplicar nova</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="custom-table" *ngSwitchCase="'geolocation'">
        <thead>
          <tr>
            <th>Colaborador</th>
            <th>Unidade</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conflict of conflicts; trackBy: trackByConflictId">
            <td>{{ getEmployeeName(conflict) }}</td>
            <td>{{ getCompanyName(conflict) }}</td>
            <td class="actions-cell">
              <div class="resolution-options">
                <label class="radio-option" [class.disabled-option]="isBulkActionActive">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="current"
                    [checked]="resolutions[conflict.id.toString()] === 'current'"
                    [disabled]="isBulkActionActive"
                    (change)="onResolutionChange(conflict.id.toString(), 'current')">
                  <span>Manter atual</span>
                </label>
                <label class="radio-option" [class.disabled-option]="isBulkActionActive">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="conflicting"
                    [checked]="resolutions[conflict.id.toString()] === 'conflicting'"
                    [disabled]="isBulkActionActive"
                    (change)="onResolutionChange(conflict.id.toString(), 'conflicting')">
                  <span>Aplicar nova</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="custom-table" *ngSwitchDefault>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Nome</th>
            <th>Configuração</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conflict of conflicts; trackBy: trackByConflictId">
            <td>{{ getConflictTypeLabel(conflict.type) }}</td>
            <td>{{ getCompanyName(conflict) !== '-' ? getCompanyName(conflict) : getAreaName(conflict) }}</td>
            <td>{{ getConfigurationName(conflict) }}</td>
            <td class="actions-cell">
              <div class="resolution-options">
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="current"
                    [checked]="resolutions[conflict.id.toString()] === 'current'"
                    (change)="onResolutionChange(conflict.id.toString(), 'current')">
                  <span>Manter atual</span>
                </label>
                <label class="radio-option">
                  <input
                    type="radio"
                    [name]="'resolution_' + conflict.id"
                    value="conflicting"
                    [checked]="resolutions[conflict.id.toString()] === 'conflicting'"
                    (change)="onResolutionChange(conflict.id.toString(), 'conflicting')">
                  <span>Aplicar nova</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

    <label class="custom-checkbox-wrapper" for="impedimento_checkbox">
      <input type="checkbox" id="impedimento_checkbox" [(ngModel)]="aceiteImpedimento">
      <span class="checkbox-text">{{ getAcknowledgementText() }}</span>
    </label>

    <div class="custom-modal-footer">
      <button class="btn-ghost" (click)="onCancel()">VOLTAR</button>
      <button
        class="btn-primary"
        [disabled]="!aceiteImpedimento || !isAllResolutionsSelected()"
        (click)="onSalvar()">
        SALVAR
      </button>
    </div>
  </div>
</div>